/**
 * @namespace Stores
 * @category Stores
 * @module events-store
 */

import i18n from '@/i18n'

const createState = () => ({
  items: [],
  detailedItems: [],
  selectedEventItem: null,
  //Events markers colors (used in events-service and nearby-events-service)
  colors: {
    0: 'red', //anomaly
    1: 'orange', //Message d’exploitation
    3: 'green', //status
  },
  //Anomaly labels by codes. Used for CitiPAV statuses.
  //Fallback to hardcoded value if translation doesn't exist in i18n
  anomalyCodeLabelMapping: {
    10001: i18n.te('events.anomaly_label.guidance_start')
      ? i18n.t('events.anomaly_label.guidance_start')
      : 'DEBUT_GUIDAGE_BAV',
    10002: i18n.te('events.anomaly_label.guidance_cancellation')
      ? i18n.t('events.anomaly_label.guidance_cancellation')
      : 'ANNULATION_GUIDAGE_BAV',
    10003: i18n.te('events.anomaly_label.guidance_end')
      ? i18n.t('events.anomaly_label.guidance_end')
      : 'FIN_GUIDAGE_BAV',
    10004: i18n.te('events.anomaly_label.bav_collect')
      ? i18n.t('events.anomaly_label.bav_collect')
      : 'COLLECTE_BAV',
    10005: i18n.te('events.anomaly_label.bav_releve')
      ? i18n.t('events.anomaly_label.bav_releve')
      : 'RELEVE_BAV',
    10006: i18n.te('events.anomaly_label.bav_ignore')
      ? i18n.t('events.anomaly_label.bav_ignore')
      : 'IGNORE_BAV',
  },
  menuCollapsed: false,
})

export default {
  namespaced: true,
  state: createState(),
  getters: {
    detailedItems: (state) => state.detailedItems,
    items: (state) => state.items,
    selectedEventItem: (state) => state.selectedEventItem,
    getAnomalyLabelByCode: (state) => (item) => {
      //Fallback to other if code not found
      if (!item?.code) {
        return i18n.te('events.anomaly_label.other')
          ? i18n.t('events.anomaly_label.other')
          : 'Autre'
      }

      const anomalyCodeLabelMapping = state.anomalyCodeLabelMapping

      return anomalyCodeLabelMapping[item.code]
        ? anomalyCodeLabelMapping[item.code]
        : i18n.te('events.anomaly_label.other')
        ? i18n.t('events.anomaly_label.other')
        : 'Autre'
    },
    menuCollapsed: (state) => state.menuCollapsed,
  },
  mutations: {
    resetItems(state) {
      state.items = []
    },
    setItems(state, items) {
      console.log(`events/index.js setItems mutation called`, {
        count: items.length,
      })
      state.items = items
    },
    resetDetailedItems(state) {
      state.detailedItems = []
    },
    updateDetailedItems(state, results) {
      state.detailedItems = [...state.detailedItems, ...results]
    },
    resetSelectedEventItem(state) {
      state.selectedEventItem = null
    },
    updateSelectedEventItem(state, item) {
      state.selectedEventItem = item
    },
  },
  actions: {},
}
